"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerVehicleEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const CustomerProfileDto_1 = require("../customer-profiles/CustomerProfileDto");
const CustomerProfileEntity_1 = require("../customer-profiles/CustomerProfileEntity");
const CustomerVehicleDto_1 = require("./CustomerVehicleDto");
const validators_1 = require("../GS/validators");
const validators_2 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const MYSQL_TEXT_MAX_LENGTH = 65535;
class CustomerVehicleEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, customerVehicle) {
        super();
        this._requiredFieldsSetStatus = {
            customerProfileId: false,
            year: false,
            make: false,
            model: false
        };
        this._dependencies = dependencies;
        if (customerVehicle === undefined) {
            this._dto = new CustomerVehicleDto_1.CustomerVehicleDto();
        }
        else if (customerVehicle instanceof CustomerVehicleDto_1.CustomerVehicleDto) {
            this._dto = new CustomerVehicleDto_1.CustomerVehicleDto(customerVehicle);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (customerVehicle instanceof CustomerVehicleEntity) {
            this._dto = new CustomerVehicleDto_1.CustomerVehicleDto(customerVehicle._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new CustomerVehicleDto_1.CustomerVehicleDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getCustomerProfile() {
        if (this._dto.customerProfileId === undefined) {
            return undefined;
        }
        if (this._dto.customerProfile === undefined) {
            throw new Error("Cannot call getCustomerProfile without " +
                "first loading the CustomerProfile.");
        }
        if (!this._customerProfileEntity && this._dto.customerProfile) {
            this._customerProfileEntity = new CustomerProfileEntity_1.CustomerProfileEntity(this._dependencies, this._dto.customerProfile);
        }
        return this._customerProfileEntity;
    }
    setCustomerProfile(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof CustomerProfileEntity_1.CustomerProfileEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof CustomerProfileDto_1.CustomerProfileDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setCustomerProfileId(untrustedId);
        if (this.hasError("customerProfileId")) {
            return;
        }
        if (untrustedValue instanceof CustomerProfileEntity_1.CustomerProfileEntity) {
            this._customerProfileEntity = untrustedValue;
        }
    }
    getCustomerProfileId() {
        return this._dto.customerProfileId;
    }
    setCustomerProfileId(untrustedValue) {
        let _untrustedValue;
        this.clearError("customerProfileId");
        this._requiredFieldsSetStatus.customerProfileId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_2.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("customerProfileId", "Customer Profile Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("customerProfileId", "Customer Profile is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.customerProfileId) {
            return;
        }
        this._dto.customerProfileId = _untrustedValue;
        delete this._customerProfileEntity;
        this._setIsDirty(true);
    }
    getIsDealervault() {
        return this._dto.isDealervault;
    }
    setIsDealervault(value) {
        this._dto.isDealervault = value;
    }
    getIsOpentrackVehcile() {
        return this._dto.isOpentrack;
    }
    setIsOpentrackVehcile(value) {
        this._dto.isOpentrack = value;
    }
    getVin() {
        return this._dto.vin;
    }
    setVin(untrustedValue) {
        const exactLength = 17;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("vin");
        if (_untrustedValue.length > 0) {
            if (_untrustedValue.length !== exactLength) {
                this.addError(new ValidationError_1.ValidationError("vin", `VIN length is incorrect (${exactLength} chr).`));
            }
            else if (!validators_1.isVin(_untrustedValue)) {
                this.addError(new ValidationError_1.ValidationError("vin", "VIN is invalid."));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.vin) {
            return;
        }
        this._dto.vin = _untrustedValue;
        this._setIsDirty(true);
    }
    getYear() {
        return this._dto.year;
    }
    setYear(untrustedValue) {
        const exactLength = 4;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("year");
        this._requiredFieldsSetStatus.year = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("year", "Year is required."));
        }
        else if (_untrustedValue.length !== exactLength) {
            this.addError(new ValidationError_1.ValidationError("year", `Year length is incorrect (${exactLength} chr).`));
        }
        else if (!validators_1.isNumeric(_untrustedValue, { no_symbols: false })) {
            this.addError(new ValidationError_1.ValidationError("year", "Year is invalid."));
        }
        if (!this.isNew && _untrustedValue === this._dto.year) {
            return;
        }
        this._dto.year = _untrustedValue;
        this._setIsDirty(true);
    }
    getMake() {
        return this._dto.make;
    }
    setMake(untrustedValue) {
        const maxLength = 50;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("make");
        this._requiredFieldsSetStatus.make = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("make", "Make is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("make", `Make has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.make) {
            return;
        }
        this._dto.make = _untrustedValue;
        this._setIsDirty(true);
    }
    getName() {
        return this._dto.name;
    }
    setName(untrustedValue) {
        const maxLength = 150;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("name");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("name", `Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.name) {
            return;
        }
        this._dto.name = _untrustedValue;
        this._setIsDirty(true);
    }
    getModel() {
        return this._dto.model;
    }
    setModel(untrustedValue) {
        const maxLength = 60;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("model");
        this._requiredFieldsSetStatus.model = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("model", "Model is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("model", `Model has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.model) {
            return;
        }
        this._dto.model = _untrustedValue;
        this._setIsDirty(true);
    }
    getOdometerReading() {
        return this._dto.odometerReading;
    }
    setOdometerReading(untrustedValue) {
        const maxLength = 9;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : null;
        this.clearError("odometerReading");
        if (typeof _untrustedValue !== "string" && _untrustedValue !== null) {
            throw new Error("Invalid type");
        }
        if (typeof _untrustedValue === "string") {
            _untrustedValue = _untrustedValue.trim().replace(",", "");
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("odometerReading", `Odometer Reading has exceeded the maximum length (${maxLength} chr).`));
            }
            else if (_untrustedValue.length > 0 &&
                !validators_1.isNumeric(_untrustedValue, { no_symbols: false })) {
                this.addError(new ValidationError_1.ValidationError("odometerReading", "Odometer Reading is invalid."));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.odometerReading) {
            return;
        }
        this._dto.odometerReading = _untrustedValue;
        this._setIsDirty(true);
    }
    getEstimatedAnnualMileage() {
        return this._dto.estimatedAnnualMileage;
    }
    setEstimatedAnnualMileage(untrustedValue) {
        const maxLength = 6;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : null;
        this.clearError("estimatedAnnualMileage");
        if (typeof _untrustedValue !== "string" && _untrustedValue !== null) {
            throw new Error("Invalid type");
        }
        if (typeof _untrustedValue === "string") {
            _untrustedValue = _untrustedValue.trim();
            if (!this.isNew && _untrustedValue === this._dto.estimatedAnnualMileage) {
                return;
            }
            _untrustedValue = _untrustedValue.replace(",", "");
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("estimatedAnnualMileage", "Estimated Annual Mileage has exceeded " +
                    `the maximum length (${maxLength} chr).`));
            }
            else if (_untrustedValue.length > 0 &&
                !validators_1.isNumeric(_untrustedValue, { no_symbols: false })) {
                this.addError(new ValidationError_1.ValidationError("estimatedAnnualMileage", "Estimated Annual Mileage is invalid."));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.estimatedAnnualMileage) {
            return;
        }
        this._dto.estimatedAnnualMileage = _untrustedValue;
        this._setIsDirty(true);
    }
    getImageUrl() {
        return this._dto.imageUrl;
    }
    setImageUrl(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("imageUrl");
        if (!validators_1.isUrl(_untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("imageUrl", "Image URL is invalid."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("imageUrl", `Image URL has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.imageUrl) {
            return;
        }
        this._dto.imageUrl = _untrustedValue;
        this._setIsDirty(true);
    }
    getCustomData() {
        return this._dto.customData;
    }
    setCustomData(untrustedValue) {
        const maxLength = MYSQL_TEXT_MAX_LENGTH;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("customData");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("customData", "Custom Data is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("customData", `Custom Data has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.customData) {
            return;
        }
        this._dto.customData = _untrustedValue;
        this._setIsDirty(true);
    }
    getAdditionalProperties() {
        return this._dto.additionalProperties;
    }
    setAdditionalProperties(untrustedValue) {
        const maxLength = MYSQL_TEXT_MAX_LENGTH;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("additionalProperties");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("additionalProperties", "Custom Data is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("additionalProperties", `Custom Data has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.additionalProperties) {
            return;
        }
        this._dto.additionalProperties = _untrustedValue;
        this._setIsDirty(true);
    }
    getOdometerUpdatedDate() {
        return this._dto.odometerUpdatedDate;
    }
    setOdometerUpdatedDate(untrustedValue) {
        const exactLength = 10;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : null;
        this.clearError("odometerUpdatedDate");
        if (typeof _untrustedValue !== "string" && _untrustedValue !== null) {
            throw new Error("Invalid type");
        }
        if (typeof _untrustedValue === "string") {
            _untrustedValue = _untrustedValue.trim();
            if (_untrustedValue.length > 0 &&
                _untrustedValue.length !== exactLength) {
                this.addError(new ValidationError_1.ValidationError("odometerUpdatedDate", `Odometer Updated Date length is incorrect (${exactLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.odometerUpdatedDate) {
            return;
        }
        this._dto.odometerUpdatedDate = _untrustedValue;
        this._setIsDirty(true);
    }
    getLastServiceDate() {
        return this._dto.lastServiceDate;
    }
    setLastServiceDate(untrustedValue) {
        const exactLength = 10;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : null;
        this.clearError("lastServiceDate");
        if (typeof _untrustedValue !== "string" && _untrustedValue !== null) {
            throw new Error("Invalid type");
        }
        if (typeof _untrustedValue === "string") {
            _untrustedValue = _untrustedValue.trim();
            if (_untrustedValue.length > 0 &&
                _untrustedValue.length !== exactLength) {
                this.addError(new ValidationError_1.ValidationError("lastServiceDate", `Last Service Date length is incorrect (${exactLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.lastServiceDate) {
            return;
        }
        this._dto.lastServiceDate = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadCustomerProfileAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getCustomerProfileId()) {
                    return;
                }
                this._emit("before-loadCustomerProfileAsync");
                this._dto.customerProfile =
                    yield this._dependencies.customerProfileDatastore
                        .getAsync(this.getCustomerProfileId(), expand);
                delete this._customerProfileEntity;
                this._emit("after-loadCustomerProfileAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_2.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.customerVehicleDatastore
                    .getAsync(id, expand);
                delete this._customerProfileEntity;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Customer Vehicle is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.customerVehicleDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.customerVehicleDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
                this.clearErrors();
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Customer Vehicle cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.customerVehicleDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.CustomerVehicleEntity = CustomerVehicleEntity;
//# sourceMappingURL=CustomerVehicleEntity.js.map